module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"show_board_description":"Board shown only boards with completed status."},"th":{"show_board_description":"บอร์ดที่แสดงเป็นบอร์ดที่มีสถานะเสร็จสิ้นเท่านั้น"}}')
  delete Component.options._Ctor
}
